import { map } from 'lodash';
import { createSelector } from 'reselect';
import { getAPIKeyEntities } from '../entities';

const getAPIKeys = (state) => state.apiKeys;

export const getVisibleAPIKeys = createSelector(
  [getAPIKeys, getAPIKeyEntities],
  (apiKeys, entities) => {
    const { sortedIds } = apiKeys;
    const items = map(sortedIds, (id) => entities[id]);

    return items;
  },
);
